import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTelegram } from './hooks/useTelegram';
import { useVisitTracker } from './hooks/useVisitTracker';
import { Home } from './components/Home';
import { ChatList } from './components/ChatList';
import { MessageList } from './components/MessageList';
import { TabBar } from './components/TabBar';
import { Userbot } from './components/Userbot';
import './App.css';

function AppContent() {
  const location = useLocation();
  const showTabBar = !location.pathname.startsWith('/chat/');

  useVisitTracker();

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chats" element={<ChatList />} />
        <Route path="/chat/:chatId" element={<MessageList />} />
        <Route path="/accounts" element={<Userbot />} />
      </Routes>
      {showTabBar && <TabBar />}
    </>
  );
}

function App() {
  const { colorScheme } = useTelegram();

  return (
    <div className={`app ${colorScheme}`}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;